import { render } from "./UpdatePaymentMethod.vue?vue&type=template&id=8911d20e&ts=true"
import script from "./UpdatePaymentMethod.vue?vue&type=script&lang=ts"
export * from "./UpdatePaymentMethod.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__